import { cn } from "@drpcrd/utils/shared";
import { ReactNode } from "react";
import { ClassNameValue } from "tailwind-merge";

type Props = { children: ReactNode; className?: ClassNameValue };

/**
 * Container component for displaying image headers on creator pages
 */
export const CreatorPageImageHeader = ({ children, className }: Props) => (
  <div className="flex w-full justify-center">
    <div
      className={cn(
        "flex h-full max-h-[180px] min-h-9 w-full max-w-56 grow flex-col overflow-hidden rounded-2xl",
        className,
      )}
    >
      {children}
    </div>
  </div>
);
